<script>
import moment from "moment";
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    datas: {
      type: Array,
    },
    size: {
      type: Number,
    },
    categories: {
      type: Array,
    },
    time: {
      type: Object,
    },
    typeTime: {
      type: String
    }
  },
  data() {
    return {
      columnChart: {
        responsive: [
          {
            breakpoint: undefined,
            options: {},
          },
        ],
        title: {},
        series: [
          {
            name: "Doanh thu",
            data: this.datas,
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: this.size,
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#556ee6"],
          xaxis: {
            labels: {
              formatter(value) {
                if (String(value).length == 6 && typeof value == "number") {
                  return "Tháng " + String(value).substring(4, 6);
                } else if (
                  String(value).length == 8 &&
                  typeof value == "number"
                ) {
                  return (
                    String(value).substring(6, 8) +
                    "/" +
                    String(value).substring(4, 6)
                  );
                } else {
                  return value;
                }
              },
            },
            categories: this.categories,
            title: {
              text: 
                ((moment(this.time.startDate).format("YYYYMM") == moment(this.time.endDate).format("YYYYMM")) && this.typeTime == 'MONTH')
                  ? `Doanh thu ${moment(this.time.startDate).format("MM/YYYY")}`
                  : ((moment(this.time.startDate).format("YYYYMMDD") == moment(this.time.endDate).format("YYYYMMDD")))
                    ? `Doanh thu ${moment(this.time.startDate).format("DD/MM/YYYY")}`
                    :  `Doanh thu ${this.typeTime == 'DAY' 
                        ? moment(this.time.startDate).format("DD/MM/YYYY")
                        : moment(this.time.startDate).format("MM/YYYY")
                      }
                      - 
                      ${this.typeTime == 'DAY' 
                        ? moment(this.time.endDate).format("DD/MM/YYYY")
                        : moment(this.time.endDate).format("MM/YYYY")} `
            },
          },
          yaxis: {
            labels: {
              formatter(value) {
                return value.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                });
              },
            },
            title: {
              text: "đ (đồng)",
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (value) {
                return value.toLocaleString("vi", {
                  style: "currency",
                  currency: "VND",
                });
              },
            },
          },
        },
      },
    };
  },
};
</script>
<template>
  <div>
    <apexchart
      class="apex-charts"
      height="350"
      type="bar"
      dir="ltr"
      :series="columnChart.series"
      :options="columnChart.chartOptions"
    ></apexchart>
  </div>
</template>